/** Kept free of the i18n instance, so a grid can print it without loading the app's translations. */
export const shortMonth = (date: Date, language?: string): string =>
  new Intl.DateTimeFormat(language, { month: 'short' }).format(date).replace('.', '');

// A sprint's dates as a compact label: "1–14 Jul" within a month, "24 Jun – 7 Jul" across two.
export const formatSprintRange = (start: Date, end: Date, language?: string): string =>
  start.getMonth() === end.getMonth()
    ? `${start.getDate()}–${end.getDate()} ${shortMonth(end, language)}`
    : `${start.getDate()} ${shortMonth(start, language)} – ${end.getDate()} ${shortMonth(end, language)}`;

export const monthLabelsIn = (starts: Date[], language?: string): string[] => {
  let previousMonth = '';
  let previousYear = -1;
  return starts.map(start => {
    const monthKey = `${start.getFullYear()}-${start.getMonth()}`;
    if (monthKey === previousMonth) return '';
    const label =
      start.getFullYear() === previousYear
        ? shortMonth(start, language)
        : `${shortMonth(start, language)} '${String(start.getFullYear()).slice(2)}`;
    previousMonth = monthKey;
    previousYear = start.getFullYear();
    return label;
  });
};
